import React, { useEffect, useState } from 'react';
import theme from './SellerSidebar.module.scss';
import { faStars } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import {
    Button,
    ExternalLinkButton,
    LoadingIndicator,
    MarkdownDisplay,
    Modal,
    ModalBody,
    ModalFooter,
} from '@ygtechnologies/bygr-frontend-component-library';
import { Button as RubusUiButton } from '@ygtechnologies/rubus-ui';
import { useCurrentCulture } from '@/utils/hooks';

const markdowns = [
    {
        lang: 'en',
        markdownImport: () => import('./customer-survey-markdowns/customer-survey_en.md?raw'),
    },
    {
        lang: 'nb',
        markdownImport: () => import('./customer-survey-markdowns/customer-survey_no.md?raw'),
    },
    {
        lang: 'sv',
        markdownImport: () => import('./customer-survey-markdowns/customer-survey_sv.md?raw'),
    },
    {
        lang: 'de',
        markdownImport: () => import('./customer-survey-markdowns/customer-survey_de.md?raw'),
    },
];

export const getMarkdown = (lang: string) => {
    const imp = markdowns.find((x) => x.lang === lang)?.markdownImport();
    if (!imp) throw Error('Cultures not supported');
    return imp;
};

export interface SellerSidebarCustomerSurveyPreviewButtonProps {
    isOpen: boolean;
    toggle: () => void;
}
export const SellerSidebarCustomerSurveyPreview: React.FC<SellerSidebarCustomerSurveyPreviewButtonProps> = ({
    isOpen,
    toggle,
}) => {
    const [cultureInfo] = useCurrentCulture();

    const [md, setMd] = useState<null | string>(null);
    useEffect(() => {
        if (cultureInfo?.languageCode) {
            async function loadMd() {
                const importMd = (await getMarkdown(cultureInfo!.languageCode)).default;
                setMd(importMd);
            }
            loadMd();
        }
    }, [cultureInfo?.languageCode]);
    return (
        <Modal size="xl" toggle={toggle} isOpen={isOpen}>
            <ModalBody>
                {!md ? <LoadingIndicator /> : <MarkdownDisplay markdown={md} className={theme.centerImages} />}
            </ModalBody>
            <ModalFooter>
                <Button onClick={toggle} color="tertiary">
                    <Trans>Close</Trans>
                </Button>
                <ExternalLinkButton href="mailto:lars@rubustech.io" color="primary">
                    <Trans>Contact for demo</Trans>
                </ExternalLinkButton>
            </ModalFooter>
        </Modal>
    );
};
